/* eslint max-len: 0 */
import kebabCase from 'lodash/kebabCase';
import type { CSSProperties, JSX } from 'react';
import * as React from 'react';

import { generateTestId } from '../../lib/test-helpers';
import { cn, IconPlus } from '../../v2';
import { Spinner } from '../spinner';

interface Props {
  label: string;
  onClick?: () => unknown;
  isLoading?: boolean;
  disabled?: boolean;
  isDragActive?: boolean;
  style?: CSSProperties;
  testId?: string;
}

export function Dropzone(props: Props): JSX.Element {
  const { label, onClick, isLoading, disabled = false, isDragActive = false, style, testId: propTestId } = props;
  const testId = propTestId ?? generateTestId(kebabCase(label), 'dropzone');

  function noop(): void {}

  function onKeyDown(e: React.KeyboardEvent): void {
    if (e.key === ' ' && onClick) {
      onClick();
    }
  }

  return (
    <div
      className={cn(
        'dropzone flex cursor-pointer rounded-md border border-dashed outline-hidden',
        'hover:border-brand-400 hover:bg-brand-100 dark:hover:border-brand-200 dark:hover:bg-steel-400',
        'text-brand-400 dark:text-brand-200',
        {
          'border-brand-400 bg-brand-100 dark:border-brand-200 dark:bg-steel-400': isDragActive,
          'pointer-events-none cursor-not-allowed opacity-40': disabled,
        },
      )}
      onKeyDown={!disabled ? onKeyDown : noop}
      onClick={!disabled ? onClick : noop}
      role="button"
      tabIndex={0}
      style={style}
      data-testid={testId}
    >
      <div className="w-full p-4">
        <div className="relative flex min-h-[23px] items-center justify-center">
          {isLoading ? (
            <Spinner />
          ) : (
            <>
              <div className="pr-2">
                <IconPlus />
              </div>
              <span className="block text-center font-semibold">{label}</span>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
